import React from 'react';
import bemCn from 'bem-cn';
import banner1Img from '../../assets/img/blog/blog-banner-1.jpg?sizes[]=600,sizes[]=900';
import banner2Img from '../../assets/img/blog/blog-banner-2.jpg?sizes[]=400,sizes[]=667';
import PictureSet from '../picture-set';
import SniffButton from '../sniff-button';
import { RouteFormatter } from '../../routes';

const b = bemCn('sniff-blog-post');

export const Banner1 = () => (
    <div className={b('banner-1')}>
        <PictureSet imgs={banner1Img} width={900} height={422} alt="Sniffspot Dog running on field" />
        <div className={b('banner-1_content')}>
            <p className="snif-p snif-semibold mb-1 pb-05">
                Get safe exercise for your dog by renting a private dog park near you
            </p>
            <p>
                <a href={RouteFormatter.listings({})}>
                    <SniffButton>Explore spots near me</SniffButton>
                </a>
            </p>
        </div>
    </div>
);

export const Banner2 = () => (
    <div className={b('banner-2')}>
        <div className={b('banner-2_content')}>
            <p className="snif-p snif-semibold mb-1 pb-05">
                Get your dog the safe enrichment they need by renting a Sniffspot
            </p>
            <p>
                <a href={RouteFormatter.listings({})}>
                    <SniffButton>Explore spots</SniffButton>
                </a>
            </p>
        </div>
        <div className={b('banner-2_img')}>
            <PictureSet imgs={banner2Img} width={500} height={667} alt="Sniffspot Dog swimming in pool" />
        </div>
    </div>
);
